
import { Game } from "@/models/Game";
import { cloneDeep, isEqual } from "lodash";
import { Component, Vue, Prop } from "vue-property-decorator";
import LanguageSelectCard from "../Base/LanguageSelectCard.vue";
import ComponseGeneral from "../Compose/ComposeTabs/ComposeGeneral.vue";
import ComponseMap from "../Compose/ComposeTabs/ComposeMap.vue";
import ComposeQuestMap from "../Compose/ComposeTabs/ComposeQuestMap.vue";
import ComponsePublish from "../Compose/ComposeTabs/ComposePublish.vue";
import SavePanel from "../Base/SavePanel.vue";
import CreatePoi from "../Compose/ComposePoiTabs/PoiAdd/CreatePoi.vue";
import CreateQuestPoi from "../Compose/ComposePoiTabs/PoiAdd/CreateQuestPoi.vue";
import ComposeQuest from "./ComposeTabs/ComposeQuest.vue";
import CreateQuest from "./ComposePoiTabs/PoiAdd/CreateQuest.vue";

@Component({
  components: {
    LanguageSelectCard,
    ComponseGeneral,
    ComponseMap,
    ComponsePublish,
    SavePanel,
    CreatePoi,
    CreateQuestPoi,
    ComposeQuestMap,
    ComposeQuest,
    CreateQuest,
  },
})
class ViewGame extends Vue {
  @Prop({ default: null }) readonly gameData!: Game;
  tabPicked = 0;
  isEditingLocked = true;
  gameDataObject = {} as Game;
  showSavePanel = false;
  isSavedOrDiscard = false;
  showPoi = false;

  created(): void {
    this.gameDataObject = cloneDeep(this.getGameData);
    this.$store.commit("gameStore/currentlyGameEditing", false);
    window.addEventListener("beforeunload", this.confirm_leaving);
  }

  handleSubmitPressed(): void {
    this.showPoi = true;
  }
  getTabs(event: any): void {
    this.tabPicked = event;
  }

  get showButton(): boolean {
    if (this.tabPicked == 2 || this.tabPicked == 3) {
      return true;
    } else {
      return false;
    }
  }

  get getButtonText(): string {
    if (this.tabPicked == 2) {
      return "Add Poi";
    }
    return "Add Quest";
  }

  discardChanges(value: boolean): void {
    this.gameDataObject = cloneDeep(this.getGameData);
    this.showSavePanel = false;
    if (value) {
      this.$store.dispatch("gameStore/addGameEditLock", {
        slug: this.gameData.key,
        value: false,
      });
      this.isEditingLocked = true;
    } else {
      this.$store.dispatch("gameStore/addGameEditLock", {
        slug: this.gameData.key,
        value: false,
      });
      this.isEditingLocked = true;
    }
  }

  get getGameData(): Game {
    return this.$store.state.gameStore.games.filter(
      (x: Game) => x.key === this.gameData.key
    )[0];
  }
  saveChanges(value: boolean): void {
    this.gameDataObject.is_edit = !value;
    this.$store.dispatch("gameStore/updateGame", this.gameDataObject);
    this.showSavePanel = false;
    if (value) {
      this.isEditingLocked = true;
      this.$store.commit("gameStore/currentlyGameEditing", false);
    } else {
      this.isSavedOrDiscard = true;
    }
  }

  updateTempObject(data: any): void {
    this.gameDataObject = cloneDeep(data);
    this.isSavedOrDiscard = false;
    if (!isEqual(this.gameDataObject, this.gameData)) {
      this.showSavePanel = true;
    } else {
      this.showSavePanel = false;
    }
  }

  handleUnlock(): void {
    this.$store.dispatch("gameStore/addGameEditLock", {
      slug: this.gameData.key,
      value: true,
    });
    this.isEditingLocked = false;
  }
  handlelock(): void {
    this.discardChanges(true);
  }
  confirm_leaving(evt: any): string {
    if (!this.isEditingLocked) {
      const unsaved_changes_warning =
        "You are currently in edit mode and potentially have unsaved changes. Proceeding will discard all changes. There is no undo. Are you sure?";
      evt.returnValue = unsaved_changes_warning;
      return unsaved_changes_warning;
    }
    return "";
  }
  closeDialog(): void {
    this.showPoi = false;
  }
  closeDialogLanguage(): void {
    this.$emit("closeDialogLanguage");
  }
}

export default ViewGame;
